// General
import "./diamonds-info-dialog.scss";
import { useEffect, forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateDiamondsInfoDialog } from "../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide, Button } from "@mui/material";
// i18next
import { useTranslation, Trans } from "react-i18next";

const DiamondsInfoDialog = () => {
  // Redux variables
  const diamondsInfoDialog = useSelector(
    (state) => state.dialog.diamondsInfoDialog
  );
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!diamondsInfoDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-DiamondsInfo-Dialog",
      },
    });
  }, [diamondsInfoDialog]);

  // Event Handlers | Button
  const onCloseDialog = () => {
    dispatch(updateDiamondsInfoDialog(false));
  };

  return (
    <Dialog
      className="custom-bottom-sheet-dialog"
      fullScreen
      open={diamondsInfoDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <div id="diamonds-info-dialog">
        <div className="padding-container">
          <div className="header">{t("settings.diamonds_info")}</div>

          <div className="diamonds-info-description">
            <Trans
              i18nKey={t("settings.diamonds_info_desc")}
              components={{ b: <b />, br: <br /> }}
            />
          </div>

          <Button
            className="close-button"
            variant="text"
            onClick={onCloseDialog}
          >
            {t("common.got_it")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default DiamondsInfoDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
